import { Component } from '@angular/core';

@Component({
  selector: 'app-check-employment-history-dialog',
  templateUrl: './check-employment-history-dialog.component.html',
  styleUrl: './check-employment-history-dialog.component.scss',
  standalone: false
})
export class CheckEmploymentHistoryDialogComponent { }
